import React, { useEffect, useState } from 'react';
import {
    Box,
    Flex,
    Text,
    Button,
    VStack,
    Badge,
    Icon,
    Avatar,
    SimpleGrid,
    Card,
    CardBody,
    Heading,
    useBreakpointValue,
    useColorModeValue,
    CloseButton
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';
import { FaClock, FaSync } from 'react-icons/fa';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Bar, Doughnut } from 'react-chartjs-2';
import 'chart.js/auto';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import NoticeBoard from '../Admin/NoticeBoard';
import Icons from '../../images/company logo.jpg'
// import NoticeBoard from "../Admin/NoticeBoard";
import EventBoard from "../Admin/EventBoard";
import { BASE_URL } from '../../Globalapi/Globalapi';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ProfileCard = () => {
    const [userData, setUserData] = useState(null);

    const [date, setDate] = useState(new Date());
    const [timetableData, setTimetableData] = useState([]);
    const [studentId] = useState(2);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const userId = sessionStorage.getItem('user_id'); // Retrieve user ID from session
    const userType = sessionStorage.getItem('user_type')

    const boysCount = 40; // Replace with actual data
    const girlsCount = 60; // Replace with actual data

    const marksData = {
        labels: ['Math', 'Science', 'English', 'History', 'Geography'],
        datasets: [
            {
                label: 'Student 1',
                data: [85, 90, 78, 92, 88],
                backgroundColor: '#4A90E2',
                barThickness: 20, // Adjust bar thickness here
            },
            {
                label: 'Student 2',
                data: [80, 85, 88, 90, 84],
                backgroundColor: '#E94E77',
                barThickness: 20, // Adjust bar thickness here
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    color: useColorModeValue('gray.700', 'gray.200'),
                },
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => `Marks: ${tooltipItem.raw}`,
                },
            },
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: useColorModeValue('gray.700', 'gray.200'),
                },
            },
            y: {
                stacked: true,
                beginAtZero: true,
                ticks: {
                    color: useColorModeValue('gray.700', 'gray.200'),
                },
            },
        },
    };
    const dummyTimetableData = [
      
    ];
    useEffect(() => {
        // Simulate a delay
        const fetchTimetable = () => {
            setTimeout(() => {
                setTimetableData(dummyTimetableData);
            }, 1000); // 1 second delay to simulate network request
        };

        fetchTimetable();
    }, [studentId]);

    const getStatus = (fromTime, toTime) => {
        const now = new Date();
        const fromTimeDate = new Date(`1970-01-01T${fromTime}`);
        const toTimeDate = new Date(`1970-01-01T${toTime}`);

        if (now > toTimeDate) return 'Completed';
        if (now >= fromTimeDate && now <= toTimeDate) return 'In Progress';
        return 'Upcoming';
    };

    const filteredTimetableData = timetableData.filter((classItem) => classItem.day === 'Friday');
    const sortedTimetableData = filteredTimetableData.slice().sort((a, b) => new Date(`1970-01-01T${a.start_time}`) - new Date(`1970-01-01T${b.start_time}`));


    useEffect(() => {
        const fetchUserData = async () => {
          try {
            const response = await fetch(`${BASE_URL}/student/all_profile.php`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ user_type: userType, user_id: userId }),
            });
            console.log('====================================');
            console.log(response);
            console.log('====================================');
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setUserData(data.data);
            console.log('====================================');
            console.log(data.data);
            console.log('====================================');
          } catch (error) {
            setError(error);
          } finally {
            setLoading(false);
          }
        };
        fetchUserData();
      }, [userType, userId]);

    const bg = useColorModeValue("green.50", "green.900");
    const borderColor = useColorModeValue("green.400", "green.500");
    return (
        <Box bg={useColorModeValue('#f7fafc', '#2D3748')} minHeight="100vh">
            <div style={{ backgroundColor: '#FBFBFD', height: '100vh', padding: '20px' }}>
                <div className="teacher-list-container">
                    <div className="header">
                        <h1 fontSize="20px">Guardian Dashboard</h1>
                        <div className="action-buttons">
                            <Button
                                className="refresh-button"
                                boxShadow="md" // Applies a medium shadow
                                backgroundColor='white'
                                fontSize='11px'
                                onClick={() => {
                                    // Add refresh functionality here
                                    console.log('Refresh button clicked');
                                }}
                                display={{ base: 'none', md: 'flex' }}
                            >
                                <FaSync color='#515B73' />
                            </Button>

                            {/* <div className="export-dropdown">
                                <Button className="export-button" backgroundColor='white' fontSize='11px' boxShadow="md">
                                    <FaPrint color='#515B73' />
                                    Print PDF
                                </Button>
                            </div> */}



                        </div>
                    </div>

                    <div className="breadcrumb">
                        <span>Guardian</span> / <span>Dashboard</span>
                    </div>
                </div>
                <div p={{ base: 0, md: 6 }}>
                    <Box p={4}>
                        <Flex
                            alignItems="center"
                            justifyContent="space-between"
                            p={2}
                            bg={bg}
                            borderWidth="1px"
                            borderColor={borderColor}
                            borderRadius="full"
                        >
                            <Flex alignItems="center">
                                <Avatar
                                    size="sm"
                                    src={Icons} // Replace with actual avatar URL or remove for a default avatar
                                    mr={3}
                                />
                                <Box>
                                    <Text fontSize="sm">
                                        <Text as="span" fontWeight="bold" color='green'>
                                            Empowering businesses with tailored tech solutions
                                        </Text>{" "}
                                        {/* has paid Fees for the{" "}
                                            <Text as="span" fontWeight="bold" color="teal.500">
                                                “Term1”
                                            </Text> */}
                                    </Text>
                                </Box>
                            </Flex>
                            <CloseButton />
                        </Flex>
                    </Box>
                    <div >
                        <Box bgGradient="linear(to-r, blue.500, blue.600)" p={6} borderRadius="lg" color="white" position="relative" maxH="177px" overflow="hidden">
                            <Flex alignItems="center">
                                <Avatar size="2xl" name={userData?.name} src={userData?.image_url} mr={6} />
                                <VStack align="start" spacing={2}>
                                    <Text fontWeight="bold" fontSize="2xl">{userData?.name}</Text>
                                    <Text fontSize="lg">Guardian of: {userData?.student_name}</Text>
                                    {/* <Text fontSize="lg">Admission No: {userData?.admission_no}</Text> */}
                                </VStack>
                                {/* <Button
                                leftIcon={<EditIcon />}
                                colorScheme="whiteAlpha"
                                variant="outline"
                                position="absolute"
                                top={4}
                                right={4}
                            >
                                Edit Profile
                            </Button> */}
                            </Flex>
                        </Box>
                    </div>
                    <Flex mb={6} direction={useBreakpointValue({ base: 'column', md: 'row' })} mt={5}>
                        {/* Left Side */}
                        <Flex direction="column" flex="2" mr={{ base: 0, md: 8 }} gap={6}>
                            {/* Profile Section */}

                            <NoticeBoard />
                            <EventBoard />
                            {/* Timetable */}
                            {/* <Box bg="white" p={6} borderRadius="lg" borderWidth="1px">
                                <Text fontWeight="bold" fontSize="lg" mb={4}>Today's Timetable</Text>
                                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                                    {sortedTimetableData.length > 0 ? (
                                        sortedTimetableData.map((classItem, index) => (
                                            <Card key={index} bg="gray.50" boxShadow="sm" _hover={{ boxShadow: 'lg', transform: 'translateY(-2px)', transition: '0.3s' }}>
                                                <CardBody>
                                                    <Flex justifyContent="space-between" alignItems="center">
                                                        <VStack align="start">
                                                            <Heading size="md">{classItem.subject}</Heading>
                                                            <Text color="gray.600">
                                                                <Icon as={FaClock} mr={2} />
                                                                {classItem.start_time} - {classItem.end_time}
                                                            </Text>
                                                        </VStack>
                                                        <Badge
                                                            colorScheme={
                                                                getStatus(classItem.start_time, classItem.end_time) === 'Completed'
                                                                    ? 'green'
                                                                    : getStatus(classItem.start_time, classItem.end_time) === 'In Progress'
                                                                        ? 'yellow'
                                                                        : 'blue'
                                                            }
                                                            variant="solid"
                                                        >
                                                            {getStatus(classItem.start_time, classItem.end_time)}
                                                        </Badge>
                                                    </Flex>
                                                </CardBody>
                                            </Card>
                                        ))
                                    ) : (
                                        <Text>No classes scheduled for today.</Text>
                                    )}
                                </SimpleGrid>
                            </Box> */}
                            {/* <Box bg="white" p={6} borderRadius="lg" borderWidth="1px" display={{ base: 'none', md: 'block' }}>
                                <Text fontWeight="bold" fontSize="lg" mb={4}>Marks Distribution</Text>
                                <div style={{ height: '375px', width: '100%' }}>
                                    <Bar data={marksData} options={chartOptions} />
                                </div>
                            </Box> */}
                        </Flex>

                        {/* Right Side */}
                        <Flex direction="column" flex="1" gap={8}>
                            {/* <NoticeBoard /> */}
                            {/* Marks Distribution */}


                            {/* Gender Distribution */}
                            {/* <Box bg="white" p={6} borderRadius="lg" boxShadow="lg">
                        <Text fontWeight="bold" fontSize="lg" mb={4}>Gender Distribution</Text>
                        <div style={{ height: '375px', width: '100%' }}>
                            <Doughnut data={{ labels: ['Boys', 'Girls'], datasets: [{ data: [boysCount, girlsCount], backgroundColor: ['#ADD8E6', '#FFB6C1'], hoverBackgroundColor: ['#87CEEB', '#FF69B4'] }] }} />
                        </div>
                    </Box> */}

                            {/* Calendar */}
                            <Box bg="white" p={6} borderRadius="lg" borderWidth="1px">
                                <Text fontWeight="bold" fontSize="lg" mb={4} color="blue.500">Schedules</Text>
                                <Box
                                    bg="gray.50"
                                    borderRadius="md"
                                    p={4}
                                    border="1px solid #e2e8f0"
                                    boxShadow="md"
                                    maxW="100%"
                                    overflow="hidden"
                                    sx={{ width: 'auto' }}
                                >
                                    <Calendar
                                        onChange={setDate}
                                        value={date}
                                        tileClassName={({ date, view }) => view === 'month' && date.getDate() === new Date().getDate() ? 'react-calendar__tile--active' : undefined}
                                    />
                                    <style jsx global>{`
                                .react-calendar {
                                    font-family: 'Poppins', sans-serif;
                                    border: none;
                                    width: auto;
                                }
                                .react-calendar__month-view__days__day {
                                    font-family: 'Poppins', sans-serif;
                                }
                                .react-calendar__tile {
                                    font-family: 'Poppins', sans-serif;
                                    border-radius: 4px;
                                    padding: 10px;
                                    transition: background-color 0.3s;
                                }
                                .react-calendar__tile--active {
                                    background-color: #3182ce;
                                    color: white;
                                    border-radius: 4px;
                                }
                                .react-calendar__tile:hover {
                                    background-color: #ebf8ff;
                                }
                            `}</style>
                                </Box>
                            </Box>
                        </Flex>
                    </Flex>
                </div>
            </div>
        </Box >
    );
};

export default ProfileCard;
